export const beachGalleryImages: Record<string, string[]> = {
    tolou: [
        "/images/ivoirexperience/the-place-to-be/galleries/tolou/legacy.png",
        "/images/ivoirexperience/the-place-to-be/tolou.jpg",
        "/images/ivoirexperience/the-place-to-be/galleries/tolou/1.jpg",
        "/images/ivoirexperience/the-place-to-be/galleries/tolou/2.jpg",
        "/images/ivoirexperience/the-place-to-be/galleries/tolou/3.jpg",
        "/images/ivoirexperience/the-place-to-be/galleries/tolou/4.jpg",
    ],
    monogaga: [
        "/images/ivoirexperience/the-place-to-be/galleries/monogaga/legacy.png",
        "/images/ivoirexperience/the-place-to-be/monogaga.jpg",
        "/images/ivoirexperience/the-place-to-be/galleries/monogaga/1.jpg",
        "/images/ivoirexperience/the-place-to-be/galleries/monogaga/2.jpg",
        "/images/ivoirexperience/the-place-to-be/galleries/monogaga/3.jpg",
        "/images/ivoirexperience/the-place-to-be/galleries/monogaga/4.jpg",
        "/images/ivoirexperience/the-place-to-be/galleries/monogaga/5.jpg",
        "/images/ivoirexperience/the-place-to-be/galleries/monogaga/6.jpg",
        "/images/ivoirexperience/the-place-to-be/galleries/monogaga/7.jpg",
        "/images/ivoirexperience/the-place-to-be/galleries/monogaga/8.jpg",
        "/images/ivoirexperience/the-place-to-be/galleries/monogaga/9.jpg",
        "/images/ivoirexperience/the-place-to-be/galleries/monogaga/10.jpg",
        "/images/ivoirexperience/the-place-to-be/galleries/monogaga/11.jpg",
        "/images/ivoirexperience/the-place-to-be/galleries/monogaga/12.jpg",
        "/images/ivoirexperience/the-place-to-be/galleries/monogaga/13.jpg",
    ],
    sassandra: [
        "/images/ivoirexperience/the-place-to-be/galleries/sassandra/1.jpg",
        "/images/ivoirexperience/the-place-to-be/galleries/sassandra/2.jpg",
        "/images/ivoirexperience/the-place-to-be/galleries/sassandra/4.jpg",
        "/images/ivoirexperience/the-place-to-be/galleries/sassandra/7.jpg",
        "/images/ivoirexperience/the-place-to-be/galleries/sassandra/11.jpg",
        "/images/ivoirexperience/the-place-to-be/galleries/sassandra/12.jpg",
        "/images/ivoirexperience/the-place-to-be/galleries/sassandra/13.jpg",
        "/images/ivoirexperience/the-place-to-be/galleries/sassandra/16.jpg",
    ],
    assinie: [
        "/images/ivoirexperience/the-place-to-be/assinie.jpg",
        "/images/ivoirexperience/the-place-to-be/galleries/assinie/2.jpg",
        "/images/ivoirexperience/the-place-to-be/galleries/assinie/3.jpg",
        "/images/ivoirexperience/the-place-to-be/galleries/assinie/4.jpg",
        "/images/ivoirexperience/the-place-to-be/galleries/assinie/5.jpg",
        "/images/ivoirexperience/the-place-to-be/galleries/assinie/6.jpg",
        "/images/ivoirexperience/the-place-to-be/galleries/assinie/7.jpg",
        "/images/ivoirexperience/the-place-to-be/galleries/assinie/8.jpg",
    ],
    "grand-bereby": [
        "/images/ivoirexperience/the-place-to-be/galleries/grand-bereby/legacy.png",
        "/images/ivoirexperience/the-place-to-be/grand-bereby.jpg",
        "/images/ivoirexperience/the-place-to-be/galleries/grand-bereby/1.jpg",
        "/images/ivoirexperience/the-place-to-be/galleries/grand-bereby/3.jpg",
        "/images/ivoirexperience/the-place-to-be/galleries/grand-bereby/4.jpg",
        "/images/ivoirexperience/the-place-to-be/galleries/grand-bereby/5.jpg",
        "/images/ivoirexperience/the-place-to-be/galleries/grand-bereby/6.jpg",
    ],
    "mani-bereby": [
        "/images/ivoirexperience/the-place-to-be/galleries/mani-bereby/legacy.png",
        "/images/ivoirexperience/the-place-to-be/galleries/mani-bereby/1.jpg",
        "/images/ivoirexperience/the-place-to-be/galleries/mani-bereby/2.jpg",
        "/images/ivoirexperience/the-place-to-be/galleries/mani-bereby/3.jpg",
        "/images/ivoirexperience/the-place-to-be/galleries/mani-bereby/4.jpg",
        "/images/ivoirexperience/the-place-to-be/galleries/mani-bereby/5.jpg",
        "/images/ivoirexperience/the-place-to-be/galleries/mani-bereby/6.jpg",
        "/images/ivoirexperience/the-place-to-be/galleries/mani-bereby/8.jpg",
    ],
    "grand-lahou": [
        "/images/ivoirexperience/the-place-to-be/galleries/grand-lahou/legacy.png",
        "/images/ivoirexperience/the-place-to-be/grand-lahou.jpg",
    ],
    dagbego: [
        "/images/ivoirexperience/the-place-to-be/galleries/dagbego/legacy.png",
        "/images/ivoirexperience/the-place-to-be/dagbego.jpg",
        "/images/ivoirexperience/the-place-to-be/galleries/dagbego/3.jpg",
        "/images/ivoirexperience/the-place-to-be/galleries/dagbego/4.jpg",
    ],
    "baie-des-milliardaires": [
        "/images/ivoirexperience/the-place-to-be/galleries/baie-des-milliardaires/legacy.png",
        "/images/ivoirexperience/the-place-to-be/baie-des-milliardaires.jpg",
    ],
    fresco: [
        "/images/ivoirexperience/the-place-to-be/galleries/fresco/legacy.png",
        "/images/ivoirexperience/the-place-to-be/galleries/fresco/legacy-2.png",
        "/images/ivoirexperience/the-place-to-be/fresco.jpg",
        "/images/ivoirexperience/the-place-to-be/galleries/fresco/1.jpg",
        "/images/ivoirexperience/the-place-to-be/galleries/fresco/2.jpg",
    ],
    kosso: [
        "/images/ivoirexperience/the-place-to-be/galleries/kosso/legacy.png",
    ],
    tabou: [
        "/images/ivoirexperience/the-place-to-be/galleries/tabou/legacy.png",
        "/images/ivoirexperience/the-place-to-be/tabou.jpg",
        "/images/ivoirexperience/the-place-to-be/galleries/tabou/2.jpg",
    ],
    taki: [
        "/images/ivoirexperience/the-place-to-be/galleries/taki/legacy.png",
    ],
};
